module.exports = __webpack_public_path__ + "static/mosquito-5481a1e16e5f801624475136c66de377.png";